import React from "react";
import { useState } from "react";
import { ReactComponent as RightSign } from "../images/right-sign.svg";
import { ReactComponent as WrongSign } from "../images/wrong-sign.svg";
import HM from "../images/hand-mobile.svg";
import lockImg from "../images/lock.svg";
import ps1 from "../images/ps-1.svg";
import ps2 from "../images/ps-2.svg";
import ps3 from "../images/ps-3.svg";

const data = [
	{
		id: 0,
		name: "BNB Smart Chain (BNB)",
		icon: "https://assets.coingecko.com/coins/images/825/standard/bnb-icon2_2x.png?1696501970",
		buy: true,
		sell: true,
		swap: true,
		stake: true,
		dapp: true,
	},

	{
		id: 1,
		name: "Bitcoin (BTC)",
		icon: "https://assets.coingecko.com/coins/images/1/standard/bitcoin.png?1696501400",
		buy: true,
		sell: true,
		swap: true,
		stake: false,
		dapp: false,
	},

	{
		id: 2,
		name: "Ethereum (ETH)",
		icon: "https://assets.coingecko.com/coins/images/279/standard/ethereum.png?1696501628",
		buy: true,
		sell: true,
		swap: true,
		stake: true,
		dapp: true,
	},

	{
		id: 3,
		name: "Polygon (Matic)",
		icon: "https://assets.coingecko.com/coins/images/4713/standard/polygon.png?1698233745",
		buy: true,
		sell: true,
		swap: true,
		stake: true,
		dapp: true,
	},

	{
		id: 4,
		name: "Tron (TRX)",
		icon: "https://assets.coingecko.com/coins/images/1094/standard/tron-logo.png?1696502193",
		buy: true,
		sell: true,
		swap: false,
		stake: false,
		dapp: true,
	},
];

const OnePlatform = () => {
	const [toggle, setToggle] = useState();
	const changeToggle = (index) => {
		setToggle(index);
		// console.log(index)
	};
	return (
		<div className="flex flex-col-reverse  overflow-hidden">
			<div
				id="yellow"
				className="z-0 max-w-[1200px] flex flex-row mx-auto h-full rounded-3xl  gradientYellowToGreen lg:px-20 sm:px-10 px-5 py-20  -mt-10"
			>
				<div className="flex flex-col w-full  bg-gray justify-between items-center ">
					{/* Text Box  */}
					<div className="w-full flex flex-col text-black/90 items-center ">
						<h1 className="text-5xl font-extrabold w-full text-center">
							Stay private and secure
						</h1>
						<p className="text-xl my-6 w-full text-center">
							Rest easy knowing that our privacy and security measures keep you
							in control of your data and digital assets, while also keeping
							them safe.
						</p>
					</div>

					{/* Left Text and Right Icon  */}
					<div className="bg-white text-black/90  w-full mx-auto px-6 rounded-2xl mt-10 mb-16 md:py-10">
						<div className="flex md:flex-row flex-col w-full mx-auto justify-between ">
							<div className="flex flex-col items-start justify-center px-5 md:w-1/2 w-full md:max-w-[350px] md:mt-0 mt-10">
								<h1 className="text-3xl font-bold">
									True ownership of your crypto assets
								</h1>
								<p className="text-base my-6">
									We secure your wallet, but don't control or have access to
									your private keys or secret phrase - only you do.
								</p>
								{/* <div className="text-white bg-blue-700 w-max font-semibold px-6 py-2 rounded-full border border-blue-600">
									Get started
								</div> */}
								<button
									className={`w-max flex justify-center items-center blue  relative serviceCardAnimation  overflow-hidden rounded-full my-10 duration-100 ${
										toggle === 2 ? "text-black" : "text-white"
									}`}
									onMouseOver={() => changeToggle(2)}
									onMouseOut={() => changeToggle(0)}
								>
									<h5 className="w-full h-full bg-sky-500 z-0 rounded-full"></h5>
									<h1 className="z-50 bg-transparent text-[0.9375rem]  px-[2.5rem] py-[0.75rem] font-medium">
										Get started
									</h1>
								</button>
							</div>
							<div className="flex items-center  justify-center  md:w-1/2 w-full p-5">
								<img src={lockImg} className="" alt="Hand Mobile" />
							</div>
						</div>
					</div>

					{/* 3 Box with Text and Icon  */}
					<div className="grid md:grid-cols-3  sm:grid-cols-2 grid-cols-1 w-full  mx-auto mt-10 gap-5">
						{/* First item */}
						<div className="flex w-full flex-col text-black/90 items-center bg-white rounded-2xl px-10 py-5 justify-center">
							<h1 className="text-2xl font-extrabold">
								Added security with encryption
							</h1>
							<img src={ps1} className="h-[100px] m-5" alt="Hand Mobile" />
							<p className="text-base my-6 text-center">
								Use our Encrypted Cloud Backup for increased wallet security.
							</p>
						</div>

						{/* Second item */}
						<div className="flex w-full flex-col text-black/90 items-center bg-white rounded-2xl px-10 py-5 pt-5 justify-center">
							<h1 className="text-2xl font-extrabold">
								Zero personal tracking
							</h1>
							<img src={ps2} className="h-[100px] m-5" alt="Hand Mobile" />
							<p className="text-base my-6 text-center">
								We don't track any personal information, including your IP
								address or balances.
							</p>
						</div>

						{/* Third item */}
						<div className="flex w-full flex-col text-black/90 items-center bg-white rounded-2xl px-10 py-5 justify-center">
							<h1 className="text-2xl font-extrabold">
								Proactive alerts for risky transactions
							</h1>
							<img src={ps3} className="h-[100px] m-5" alt="Hand Mobile" />
							<p className="text-base my-6 text-center">
								Stay safe with alerts for risky address and dApp connections.
							</p>
						</div>
					</div>

					<button className="w-max font-semibold px-6 py-2 rounded-full border border-black/90 hover:text-white hover:bg-black duration-500 cursor-pointer my-10">
						Learn more about privacy and security
					</button>
				</div>
			</div>
			<div
				id="green"
				className="z-0 max-w-[1200px] flex flex-row mx-auto h-full rounded-bl-3xl rounded-br-3xl gradientYellowToPink lg:px-36 sm:px-10 px-5 py-20  -mt-10"
			>
				<div className=" flex flex-col w-full  bg-gray justify-between ">
					{/* Text box  */}
					<div className=" w-full flex flex-col text-black/90 items-center ">
						<h1 className="text-5xl font-extrabold  text-center w-full">
							Simple. Seamless.
						</h1>
						<p className="text-xl my-6 text-center max-w-4xl">
							Enjoy a smooth mobile app and desktop experience with easy-to-use,
							powerful tools to support your entire Web3 journey.
						</p>
					</div>

					{/* Left Text and Right Icon  */}
					<div className="bg-white text-black/90  w-full mx-auto  rounded-2xl mt-10  mb-16 ">
						<div className="flex md:flex-row flex-col w-full mx-auto justify-between  lg:gap-20 gap-10 ">
							<div className="flex flex-col items-start justify-center px-5 md:w-1/2 w-full md:max-w-[350px] md:mt-0 mt-10">
								<h1 className="text-3xl font-bold">
									Deposit crypto easily from exchanges
								</h1>
								<p className="text-base my-6">
									Take control of your crypto. Avoid complicated steps and
									deposit directly to your wallet from exchanges like Binance
									and Coinbase.
								</p>
								<button className=" w-max px-10 font-semibold py-3 rounded-full border border-blue-700 bluehover duration-300">
									Get started with deposit
								</button>
							</div>
							<div className="flex items-center  justify-center  md:w-1/2 w-full">
								<img src={HM} className="h-[350px] w-full " alt="Hand Mobile" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				id="blue"
				className="z-40 max-w-[1200px] flex flex-row mx-auto h-full rounded-2xl gradientLightBlueToBlue sm:p-10 p-5 py-10 "
			>
				<div className=" w-full flex flex-col w-full  bg-gray justify-between">
					<div className=" w-full flex flex-col text-white items-center gap-5 ">
						<h1 className=" text-4xl lg:text-5xl font-extrabold text-white w-full text-center mt-5">
							One Platform, Millions of Assets
						</h1>
						<p className="text-xl  w-full text-center ">
							As a leading self-custody multi-chain platform, we support
							millions of assets for all the major blockchains. From Bitcoin,
							Ethereum, and Solana, to Cosmos, Optimism, and much more.
						</p>
					</div>
					<div className="overflow-hidden lg:w-full md:[90vw]   sm:w-[86vw] w-[86vw]">
						<div className="bg-white text-black/80 w-full px-6 py-3 rounded-2xl mt-10  overflow-scroll">
							<table className="table-auto w-full mt-8 min-w-[700px] ">
								<thead>
									<tr>
										<th className=" py-2 text-center w-[30%] ">Chain</th>
										<th className=" py-2 text-center  items-center w-[10%]    ">
											Buy
										</th>
										<th className=" py-2 text-center  items-center w-[10%]    ">
											Sell
										</th>
										<th className=" py-2 text-center  items-center w-[10%]    ">
											Swap
										</th>
										<th className=" py-2 text-center  items-center w-[10%]    ">
											Stake
										</th>
										<th className=" py-2 text-center  items-center w-[10%]    ">
											dApps
										</th>
									</tr>
								</thead>
								<tbody>
									{data.map((item, index) => (
										<tr key={index}>
											<td className="p-4 w-[30%]">
												<div className="flex flex-row items-center">
													<img
														className="h-[30px] w-[30px]"
														src={item.icon}
														alt="Logo"
													/>
													<p className="ml-4">{item.name}</p>
												</div>
											</td>
											<td className="py-2 text-center w-5 items-center w-[10%]   ">
												{item.buy ? (
													<RightSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												) : (
													<WrongSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												)}
											</td>
											<td className="py-2 text-center w-5 items-center w-[10%]    ">
												{item.sell ? (
													<RightSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												) : (
													<WrongSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												)}
											</td>
											<td className="py-2 text-center w-5 items-center w-[10%]    ">
												{item.swap ? (
													<RightSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												) : (
													<WrongSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												)}
											</td>
											<td className="py-2 text-center w-5 items-center w-[10%]   ">
												{item.stake ? (
													<RightSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												) : (
													<WrongSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												)}
											</td>
											<td className="py-2 text-center w-5 items-center w-[10%]    ">
												{item.dapp ? (
													<RightSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												) : (
													<WrongSign className="h-5 w-5 text-green-500 flex justify-center items-center w-full" />
												)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
					<div className="flex flex-row md:justify-between justify-center my-14 flex-wrap items-center">
						<h1 className="text-white font-extrabold text-2xl sm:text-3xl m-3">
							Many Assets{" "}
						</h1>
						<h1 className="text-white font-extrabold text-2xl sm:text-3xl m-3">
							 Staking{" "}
						</h1>
						<h1 className="text-white font-extrabold text-2xl sm:text-3xl m-3">
							Major Blockchains
						</h1>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OnePlatform;
